import { ESRI } from '../../constants/mapProviders';

/**
 * Updates and returns the given marker instance
 * @param {Object} mapObject - map provider
 * @param {Instance} marker - instance of the marker
 * @param {Object} options - options for the marker
 * @param {Object} options.icon - the svg icon used for the marker
 * @param {Object} options.iconSize
 * @param {Number} options.iconSize.height - height in px
 * @param {Number} options.iconSize.width - width in px
 * @param {Object} options.position
 * @param {Number} options.position.lat - latitude
 * @param {Number} options.position.lng - longitude
 *
 */
const updateMarker = ({ mapObject, marker, options = {} }) => {
  switch (mapObject.mapProvider) {
    // Currently only used for updating the icon, position
    case ESRI: {
      // Update marker icon
      if (options.icon) {
        const symbol = {
          type: 'picture-marker',
          url: options.icon,
          height: `${options?.iconSize?.height ? options.iconSize.height : 30}`,
          width: `${options?.iconSize?.width ? options.iconSize.width : 30}`,
        };
        marker.symbol = symbol;
      }
      // Update marker position
      if (options.position) {
        const geometry = {
          type: 'point',
          longitude: options.position.lng,
          latitude: options.position.lat,
        };
        marker.graphic.geometry = geometry;
      }
      break;
    }
  }
  return marker;
};

export default updateMarker;
